/* eslint-disable @typescript-eslint/indent */
import { useEffect, useLayoutEffect } from 'react';
import { useQuery } from 'react-query';

import Helmet from '@/components/meta/Helmet';
import VelodromeInfoTemplate from '@/components/templates/Velodrome/Info';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { client } from '@/lib/microcms';
import { VelodromeRoutesProps } from '@/routes/Velodrome';
import { mq } from '@/utility/mediaQuery';

const VelodromeInfoPage: React.FC<VelodromeRoutesProps> = ({ velodrome }) => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: `${velodrome.name}競輪`,
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles({
      customStyles: mq({
        width: '100%',
      }),
    });
  }, []);

  const { data } = useQuery(['velodrome', velodrome.romanName], async () =>
    client.getContent('velodrome', velodrome.romanName),
  );

  const title = `${velodrome.name}競輪場`;

  return (
    <>
      <Helmet
        meta={{
          title,
          description: `${title}のページです。%s`,
          keywords: `${title},%s`,
        }}
      />
      <VelodromeInfoTemplate
        velodromeName={velodrome.name}
        velodromeInfo={data}
      />
    </>
  );
};
export default VelodromeInfoPage;
